import { useNavigate } from "react-router-dom";

const buttonsList = ["Music", "Cricket", "Comedy", "Live", "Gaming", "Podcast", "Cooking"];

const ButtonComponent = ({ name, handleClick }) => {
  return (
    <button
      className="px-3 py-1 md:px-5 md:py-2 m-1 md:m-2 text-sm font-medium text-gray-700 transition-all 
    bg-gray-100 rounded-lg hover:bg-gray-200 hover:shadow-md"
      onClick={handleClick}
    >
      {name}
    </button>
  )
}

const ButtonsList = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap overflow-hidden max-h-[44px] justify-center px-2 md:px-0">
      {buttonsList.map(button => <ButtonComponent name={button} key={button} handleClick={() => navigate("/search?q=" + encodeURIComponent(button))} />)}
    </div>
  )
}

export default ButtonsList